import "3pp/core3pps";
import { run } from "./bootstrapper";

run(window);
